/* Don Kroketon · Catálogo Linktree: acciones por producto (2026-09-23, autorizado por Erick).
   - Foto pequeña y nombre enlazado a la ficha (/products/<handle>).
   - Presentación elegible (toque en la fila) y dos botones: "Pedir por WhatsApp" con el pedido ya escrito
     (producto, presentación, precio de hoy, código CAT) y "Comprar en línea" (agrega esa presentación al carrito).
   - Banda "Hoy": botón que salta a la marca en promoción. WhatsApp flotante como pastilla a la izquierda.
   Solo presentación: los precios salen del propio catálogo (data-today-price) y el cobro lo hace Shopify. */
(function () {
  var WA = '523312437190';
  var root = document.getElementById('ct-root');
  if (!root) return;

  function money(cents) {
    var n = Number(cents) / 100;
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }

  function selectVariant(art, li) {
    art.querySelectorAll('.ct-variant.dkx-sel').forEach(function (x) { x.classList.remove('dkx-sel'); x.setAttribute('aria-checked', 'false'); });
    li.classList.add('dkx-sel'); li.setAttribute('aria-checked', 'true');
    updateActions(art);
  }
  function soldOut(li) { return /agotado/i.test(li.textContent); }

  function updateActions(art) {
    var li = art.querySelector('.ct-variant.dkx-sel');
    var box = art.querySelector('.dkx-acts');
    if (!li || !box) return;
    var title = art.dataset.title || '';
    var name = (li.querySelector('.ct-v__name') || {}).textContent || '';
    var cents = li.dataset.todayPrice;
    var pct = parseFloat(li.dataset.todayPct || '0');
    var msg = 'Hola, quiero pedir:\n' + title + ' ' + name.trim() + '\nPrecio de hoy: ' + money(cents) +
      (pct > 0 ? ' (' + (pct % 1 ? pct : Math.round(pct)) + '% de descuento hoy)' : '') + '\nCantidad: 1\nCódigo: CAT';
    var wa = box.querySelector('.dkx-wa');
    wa.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(msg);
    var buy = box.querySelector('.dkx-buy');
    if (soldOut(li)) { buy.removeAttribute('href'); buy.classList.add('is-off'); buy.textContent = 'Agotado en línea'; }
    else { buy.href = '/cart/add?id=' + li.dataset.variantId + '&quantity=1'; buy.classList.remove('is-off'); buy.textContent = 'Comprar en línea'; }
  }

  function enhance(art, info) {
    if (art.dataset.dkx) return;
    art.dataset.dkx = '1';
    var handle = art.dataset.handle;
    var url = '/products/' + handle;
    var h = art.querySelector('.ct-product__title');
    if (h && !h.querySelector('a')) {
      var a = el('a', 'dkx-title'); a.href = url; a.textContent = h.textContent.trim();
      h.textContent = ''; h.appendChild(a);
    }
    if (info && info.img) {
      var im = el('img', 'dkx-img'); im.src = info.img; im.alt = art.dataset.title || ''; im.loading = 'lazy'; im.width = 64; im.height = 64;
      var link = el('a', 'dkx-img-link'); link.href = url; link.appendChild(im);
      art.insertBefore(link, art.firstChild);
      art.classList.add('dkx-has-img');
    }
    var lis = art.querySelectorAll('.ct-variant');
    lis.forEach(function (li) {
      li.setAttribute('role', 'radio'); li.setAttribute('tabindex', '0'); li.setAttribute('aria-checked', 'false');
      li.addEventListener('click', function () { selectVariant(art, li); });
      li.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectVariant(art, li); } });
    });
    var box = el('div', 'dkx-acts');
    var wa = el('a', 'dkx-wa', 'Pedir por WhatsApp'); wa.target = '_blank'; wa.rel = 'noopener';
    var buy = el('a', 'dkx-buy', 'Comprar en línea');
    box.appendChild(wa); box.appendChild(buy);
    art.appendChild(box);
    var first = Array.prototype.find.call(lis, function (li) { return !soldOut(li); }) || lis[0];
    if (first) selectVariant(art, first);
  }

  function todayLinks() {
    var band = root.querySelector('.ct-today');
    if (!band || band.querySelector('.dkx-today-go')) return;
    var tiles = Array.prototype.slice.call(root.querySelectorAll('a.ct-brand-btn[href^="#marca-"]'));
    band.querySelectorAll('.ct-today__item').forEach(function (item) {
      var txt = item.textContent.toLowerCase();
      tiles.forEach(function (t) {
        var img = t.querySelector('img');
        var nm = ((img && img.alt) || t.textContent || '').trim();
        if (nm && txt.indexOf(nm.toLowerCase()) !== -1 && !band.querySelector('[href="' + t.getAttribute('href') + '"]')) {
          var go = el('a', 'dkx-today-go', 'Ver promoción '); go.appendChild(el('span', 'dkx-arr', '→')); go.setAttribute('aria-label', 'Ver promoción de ' + nm); go.href = t.getAttribute('href');
          item.appendChild(go);
        }
      });
    });
  }

  function waPill() {
    var f = document.querySelector('.ct-wa-float');
    if (f && !f.querySelector('.dkx-wa-txt')) { f.appendChild(el('span', 'dkx-wa-txt', '¿Dudas? WhatsApp')); f.classList.add('dkx-pill'); }
  }

  // Fotos y URLs desde la misma colección que alimenta el catálogo (2–3 peticiones, no una por producto).
  var info = {};
  function loadPage(p) {
    return fetch('/collections/catalogo-linktree/products.json?limit=250&page=' + p, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        (j.products || []).forEach(function (pr) {
          var src = pr.images && pr.images[0] && pr.images[0].src;
          info[pr.handle] = { img: src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=128' : null };
        });
        return (j.products || []).length === 250 && p < 4 ? loadPage(p + 1) : null;
      });
  }
  function run() { root.querySelectorAll('article.ct-product').forEach(function (a) { enhance(a, info[a.dataset.handle]); }); }

  todayLinks();
  waPill();
  run(); // botones de inmediato; las fotos llegan después
  loadPage(1).then(function () {
    root.querySelectorAll('article.ct-product').forEach(function (a) {
      var i = info[a.dataset.handle];
      if (i && i.img && !a.querySelector('.dkx-img')) {
        var im = el('img', 'dkx-img'); im.src = i.img; im.alt = a.dataset.title || ''; im.loading = 'lazy'; im.width = 64; im.height = 64;
        var link = el('a', 'dkx-img-link'); link.href = '/products/' + a.dataset.handle; link.appendChild(im);
        a.insertBefore(link, a.firstChild); a.classList.add('dkx-has-img');
      }
    });
  }).catch(function () {});
  // El catálogo carga páginas extra (>250 productos) de forma dinámica: aplicar también a lo nuevo.
  new MutationObserver(function () { run(); }).observe(root, { childList: true, subtree: true });
})();
